import { useState, useEffect, useRef } from 'react';
import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Snackbar, Alert } from '@mui/material';
import axios from 'axios';
import ClientMaster from '../../ClientMaster';
import LeadSourceMaster from './LeadSourceMaster';
import ActivityMaster from './ActivityMaster';
import CurrencyMaster from '../../CurrencyMaster';
import LeadStatusMaster from './LeadStatusMaster';
import UserMaster from '../../UserMaster';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useAuth } from '../../../context/AuthContext';
import { useConfigure } from '../../../context/ConfigureContext';
import dayjs from 'dayjs';
import { useTheme, useMediaQuery } from '@mui/material';
import { toProperCase } from '../../../utils/formatRows';

const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

const parseDateFlexible = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dayjs(dateStr, 'YYYY-MM-DD');
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) return dayjs(dateStr, 'DD/MM/YYYY');
    return null;
};

export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, isOrderLocked }) {
    const { user, selectedCompany, loading } = useAuth();
    const { isFeatureEnabled } = useConfigure();
    const showCurrency = isFeatureEnabled('Show Currency?');
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const clientInit = initialData.client ?? initialData;
    console.log('Company search results:', initialData);
    const API = connectionString;
    const partyDropdownRef = useRef(null);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // ─── client search state ─────────────────────────────────────────────
    const [companyName, setCompanyName] = useState(initialData.companyName || initialData.FirmName || '');
    const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
    const [searchResults, setSearchResults] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [clientError, setClientError] = useState(false);

    // ─── account dropdown state ──────────────────────────────────────────
    const [accountOptions, setAccountOptions] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);

    // ─── other form state ────────────────────────────────────────────────
    const [details, setDetails] = useState(initialData.details || []);
    const [error, setError] = useState('');
    const [quotationNumber, setquotationNumber] = useState(initialData.qoutationNumber || '');
    const [qoutationDate, setqoutationDate] = useState(mode === 'add' ? dayjs() : initialData.qoutationDate && dayjs(initialData.qoutationDate, 'DD/MM/YYYY').isValid() ? dayjs(initialData.qoutationDate, 'DD/MM/YYYY') : dayjs());
    const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
    const [referenceDate, setReferenceDate] = useState(mode === 'add' ? null : initialData.referenceDate && parseDateFlexible(initialData.referenceDate) ? parseDateFlexible(initialData.referenceDate) : null);
    const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
    const [qnextFollowUpDate, setqnextFollowUpDate] = useState(mode === 'add' ? dayjs().add(7, 'day') : initialData.qnextFollowUpDate && dayjs(initialData.qnextFollowUpDate, 'DD/MM/YYYY').isValid() ? dayjs(initialData.qnextFollowUpDate, 'DD/MM/YYYY') : dayjs().add(7, 'day'));
    const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
    const [project, setProject] = useState(initialData.project || '');
    const [agentName, setAgentName] = useState(initialData.agentName || '');
    const [agentCommission, setAgentCommission] = useState(initialData.agentCommission || '');
    const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

    // ─── masters & popups ────────────────────────────────────────────────
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    const [selectedLeadSource, setSelectedLeadSource] = useState(null);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [activityOptions, setActivityOptions] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [statusOptions, setStatusOptions] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);

    const [openClientPopup, setOpenClientPopup] = useState(false);
    const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
    const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
    const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
    const [openActivityPopup, setOpenActivityPopup] = useState(false);
    const [openStatusPopup, setOpenStatusPopup] = useState(false);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const [termsOptions, setTermsOptions] = useState([]);
    const [selectedTerms, setSelectedTerms] = useState(initialData.selectedTerms || null);
    const [termsInputValue, setTermsInputValue] = useState('');



    const fetchLastTerms = async () => {
        try {
            const res = await axios.get(`${API}/api/last-terms-type`, {
                params: {
                    mode: 'PurchaseOrder',
                    companyId
                }
            });

            const termsValue = res?.data?.TermsType;

            console.log("modeee", mode)

            // Only for add/ref mode
            if (
                termsValue &&
                (mode === 'add')
            ) {
                setSelectedTerms({
                    label: String(termsValue)
                });
            }

        } catch (err) {
            console.error("Error fetching last terms", err);
        }
    };

    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const { data: response } = await axios.get(`${API}/api/termscondition/search`, {
                    params: { companyId, mode: 'search' },
                    validateStatus: (status) => status >= 200 && status < 400,
                });
                const data = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
                console.log(data)
                const options = data.map(item => ({
                    label: item.TermsType || item.TermsName || ''
                }));
                setTermsOptions(options);
            } catch (err) {
                console.error('Error fetching terms:', err);
                setTermsOptions([]);
            }
        };

        if (companyId) {
            fetchTerms();
            fetchLastTerms();
        }


    }, [companyId]);

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const handlePopupClose = (data) => {
        if (data?.success) {
            setSnackbar({
                open: true,
                message: data.message,
                severity: "success"
            });
        }
    };

    // ─── When currencyOptions load or initialData.currencyId changes ──────
    useEffect(() => {
        if (!currencyOptions || currencyOptions.length === 0) return;
        const cid = initialData?.currencyId ?? null;
        if (cid == null) return;
        const found = currencyOptions.find(opt => String(opt.id) === String(cid));
        if (found) {
            setSelectedCurrency(found);
        } else {
            setSelectedCurrency({ id: null, label: '-' });
        }
    }, [currencyOptions, initialData?.currencyId]);

    // ─── Load auto-generated inquiry number ───────────────────────────────
    useEffect(() => {
        if (mode !== 'add' || !companyId) return;
        fetchReceiptNo();
    }, [mode, companyId]);

    async function fetchReceiptNo() {
        try {
            const { data } = await axios.get(`${API}/api/get-PurcOrder-Number`, {
                headers: { 'Cache-Control': 'no-cache' },
                params: { companyId },
            });
            console.log('[STEP4] Fetched purchase order number:', data);
            setquotationNumber(data.PurcOrderNumber || '');
        } catch (err) {
            console.error('Error fetching purchase order number:', err);
            setquotationNumber('');
        }
    }

    // ─── Load all master lists including accounts ─────────────────────────
    useEffect(() => {
        const fetchMasters = async () => {
            try {
                const [cur, acc] = await Promise.all([
                    axios.get(`${API}/currencymaster/search?mode=search&companyId=${companyId}`),
                    axios.get(`${API}/api/company-search`, { params: { field: 'FirmName' } })
                ]);
                const currencyData = transform(cur.data || [], 'CurrencyId', 'CurrencySymbol');
                const accountData = transform(acc.data.data || [], 'id', 'FirmName', companyId);
                console.log('Currency data:', cur.data);
                console.log('Account data:', acc.data.data);
                setCurrencyOptions(currencyData);
                setAccountOptions(accountData);
                if (initialData.currencyId) {
                    const found = currencyData.find(opt => String(opt.id) === String(initialData.currencyId));
                    setSelectedCurrency(found || { id: null, label: '-' });
                } else {
                    setSelectedCurrency({ id: null, label: '-' });
                }
                if (initialData.accountId) {
                    const found = accountData.find(opt => String(opt.id) === String(initialData.accountId));
                    setSelectedAccount(found || null);
                } else {
                    setSelectedAccount(null);
                }
            } catch (err) {
                console.error('Error fetching masters:', err);
                setCurrencyOptions([]);
                setAccountOptions([]);
                setLeadSourceOptions([]);
                setEmployeeOptions([]);
                setActivityOptions([]);
                setStatusOptions([]);
                setSelectedCurrency({ id: null, label: '-' });
                setSelectedLeadSource({ id: null, label: '-' });
                setSelectedEmployee({ id: null, label: '-' });
                setSelectedActivity({ id: null, label: '-' });
                setSelectedStatus({ id: null, label: '-' });
                setSelectedAccount(null);
            }
        };
        fetchMasters();
    }, [initialData.currencyId, initialData.accountId]);

    // ─── Initialize from initialData ─────────────────────────────────────
    useEffect(() => {
        if (!initialData || Object.keys(initialData).length === 0) return;

        setCompanyName(initialData.companyName || initialData.FirmName || '');
        setSelectedClientId(initialData.clientId ?? null);

        if (mode === 'edit') {
            setSelectedTerms(
                initialData.TermsType
                    ? {
                        id: initialData.TermsType,
                        label: String(initialData.TermsType)
                    }
                    : null
            );
        }

        if (initialData.details) {
            if (Array.isArray(initialData.details)) {
                setDetails(initialData.details);
            } else if (typeof initialData.details === 'object') {
                const arr = Object.entries(initialData.details).map(([label, value]) => ({ label, value }));
                setDetails(arr);
            }
        } else {
            const c = {
                city: initialData.city || '',
                state: initialData.state || '',
                mobileNo: initialData.mobileNo || '',
                emailId: initialData.emailId || '',
                contactPerson: initialData.contactPerson || '',
                gstNumber: initialData.gstNumber || ''
            };
            setDetails([
                { label: 'City', value: c.city },
                { label: 'State', value: c.state },
                { label: 'mobileNo', value: c.mobileNo },
                { label: 'Email', value: c.emailId },
                { label: 'ContactPerson', value: c.contactPerson },
                { label: 'GST No.', value: c.gstNumber }
            ]);
        }

        if (mode === 'edit') {
            setqoutationDate(initialData.inquiryDate ? parseDateFlexible(initialData.inquiryDate) || dayjs() : dayjs());
            setReferenceDate(initialData.referenceDate ? parseDateFlexible(initialData.referenceDate) || null : null);
            setqnextFollowUpDate(initialData.nextFollowUpDate ? parseDateFlexible(initialData.nextFollowUpDate) || dayjs().add(7, 'day') : dayjs().add(7, 'day'));
            setReferenceNumber(initialData.referenceNumber || '');
            setquotationNumber(initialData.quotationNumber || '');
        } else if (mode === 'add') {
            setqoutationDate(dayjs());
            setReferenceDate(initialData.referenceDate ? parseDateFlexible(initialData.referenceDate) || null : null);
            setqnextFollowUpDate(dayjs().add(7, 'day'));
            setReferenceNumber(initialData.referenceNumber || '');
        }

        setExchangeRate(initialData.exchangeRate || '');
        setKindAttend(initialData.kindAttend || '');
        setProject(initialData.project || '');
        setAgentName(initialData.agentName || '');
        setAgentCommission(initialData.agentCommission || '');
        setRemark(initialData.remark || initialData.remarks || '');
    }, [initialData, mode]);

    // ─── Fetch search results for party ───────────────────────────────────
    // Debounced 350ms so a fast typist doesn't fire one API call per keystroke —
    // the search still starts automatically as the user types, just waits for a
    // brief pause before actually calling the API.
    useEffect(() => {
        if (!companyName || !dropdownOpen) {
            setSearchResults([]);
            return;
        }

        const timeoutId = setTimeout(() => {
            const fetch = async () => {
                try {
                    const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
                    const data = Array.isArray(res.data.data) ? res.data.data : [];
                    console.log('Company search results:', data);
                    setSearchResults(data);
                    setHighlightedIndex(0);
                } catch (err) {
                    console.error('Error fetching company search results:', err);
                    setSearchResults([]);
                }
            };
            fetch();
        }, 350);

        return () => clearTimeout(timeoutId);
    }, [companyName, dropdownOpen]);

    // ─── Handle row selection in table ────────────────────────────────────
    const onSelectResult = r => {
        setSelectedClientId(r.id);
        setCompanyName(r.FirmName || r.companyName || '');
        setAgentName(r.AgentName || '');
        setAgentCommission(r.AgentComm || '');

        const c = {
            City: r.City || '',
            state: r.state || '',
            MobileNo: r.MobileNo || '',
            EmailId: r.EmailId || '',
            ContactPerson: r.ContactPerson || '',
            GSTNo: r.GSTNo || ''
        };
        setDetails([
            { label: 'City', value: c.City },
            { label: 'State', value: c.state },
            { label: 'mobileNo', value: c.MobileNo },
            { label: 'Email', value: c.emailId },
            { label: 'ContactPerson', value: c.ContactPerson },
            { label: 'GST No.', value: c.GSTNo }
        ]);
        setDropdownOpen(false);
        setClientError(false);
    };

    // ─── Dropdown field for Autocomplete ──────────────────────────────────
    const dropdownField = (label, options, value, setValue) => (
        <Grid item xs={12} sm={8} md={12}>
            <Autocomplete
                fullWidth
                options={options}
                getOptionLabel={opt => opt?.label || ''}
                value={value}
                onChange={(_, v) => setValue(v)}
                isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
                disabled={!isEditable}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        size="small"
                        InputLabelProps={{ shrink: Boolean(value) }}
                        sx={{
                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                        }}
                    />
                )}
            />
        </Grid>
    );

    // ─── Next button ─────────────────────────────────────────────────────
    const handleNext = () => {
        if (!companyName && !quotationNumber) {
            setError('Party & Order No. are required.');
            return;
        }
        if (qnextFollowUpDate && qoutationDate && qnextFollowUpDate.isValid() && qoutationDate.isValid() && qnextFollowUpDate.isBefore(qoutationDate)) {
            setError('Next follow-up must be after order date.');
            return;
        }
        if (!selectedClientId) {
            setClientError(true);
            return;
        }
        setError('');

        console.log('Selected currency (state):', selectedCurrency);
        console.log('Exchange rate (state):', exchangeRate);
        console.log('kindAttend, project, remark:', kindAttend, project, remark);

        const payload = {
            clientId: selectedClientId,
            companyName,
            inquiryDate: qoutationDate && qoutationDate.isValid() ? qoutationDate.format('YYYY-MM-DD') : '',
            referenceNumber,
            referenceDate: referenceDate && referenceDate.isValid() ? referenceDate.format('YYYY-MM-DD') : '',
            editreferenceNumber: initialData?.editreferenceNumber || '',
            currencyId: selectedCurrency?.id ?? null,
            exchangeRate: exchangeRate === '' ? '' : Number(exchangeRate),
            nextFollowUpDate: qnextFollowUpDate && qnextFollowUpDate.isValid() ? qnextFollowUpDate.format('YYYY-MM-DD') : '',
            kindAttend,
            remarks: remark,
            project,
            selectedEmployee: selectedEmployee?.id ?? null,
            selectedLeadSource: selectedLeadSource?.id ?? null,
            selectedActivity: selectedActivity?.id ?? null,
            selectedStatus: selectedStatus?.id ?? null,
            agentName,
            agentCommission,
            accountId: selectedAccount?.id ?? 0,
            qoutationNumber: quotationNumber,
             TermsType: selectedTerms?.label || null,
            details: details.reduce((acc, curr) => {
                acc[curr.label] = curr.value;
                return acc;
            }, {}),
        };

        console.log('ClientDetails onNext payload:', payload);
        onNext(payload);
    };

    // ─── Allow editing only in 'add' or 'edit' modes ─────────────────────
    // const isEditable = mode === 'add' || mode === 'edit';
    const isEditable = (mode === 'add' || mode === 'edit') && !isOrderLocked;

    return (
        <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
            <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
                <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>
                    {/* Party dropdown */}
                    <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
                        onBlur={e => {
                            if (!partyDropdownRef.current.contains(e.relatedTarget)) {
                                setDropdownOpen(false);
                            }
                        }}
                    >
                        <TextField autoFocus={mode === 'add'} disabled={!isEditable} fullWidth size="small" label="Party Name" variant="outlined" value={toProperCase(companyName)} required InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }}
                            sx={{
                                '& .MuiOutlinedInput-root': { height: '38px', display: 'flex', alignItems: 'center' },
                                '& .MuiOutlinedInput-input': { padding: '0 12px' }
                            }}
                            error={clientError}
                            onChange={e => {
                                setCompanyName(toProperCase(e.target.value));
                                setDropdownOpen(true);
                                setSelectedClientId(null);   //  invalidate
                                setClientError(false);
                            }}
                            onBlur={() => {
                                if (companyName && !selectedClientId) {
                                    setClientError(true);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (!dropdownOpen || searchResults.length === 0) return;
                                if (e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
                                } else if (e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                                } else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const selected = searchResults[highlightedIndex];
                                    if (selected) {
                                        onSelectResult(selected);
                                        setCompanyName(toProperCase(selected.FirmName));
                                        setClientError(false);
                                        setDropdownOpen(false);
                                    }
                                } else if (e.key === 'Escape') {
                                    setDropdownOpen(false);
                                }
                            }}
                            helperText={
                                clientError
                                    ? "Please select a client from the list"
                                    : ""
                            }
                        />
                        {/* {dropdownOpen && (
                            <TableContainer component={Paper} elevation={0} sx={{ mt: 1, maxHeight: 240, position: 'absolute', width: '120%', zIndex: 10, border: 'none', overflow: 'auto', border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1 }} >
                                <Table
                                    size="small"
                                    sx={{
                                        borderCollapse: 'separate',
                                        borderSpacing: 0,
                                        tableLayout: 'fixed',              // force cells to obey widths
                                        '& thead th': {
                                            backgroundColor: '#1877F2',
                                            color: '#fff',
                                            fontWeight: 600,
                                            fontSize: '0.75rem',
                                            border: 'none'
                                        },
                                        '& th, & td': {                    // reduce padding between columns
                                            padding: '4px 6px',              // smaller vertical & horizontal padding
                                            fontSize: '0.75rem',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        },
                                        // option: collapse borders so there is no extra gap
                                        '& .MuiTableCell-root': {
                                            borderRight: '0px'               // remove right cell border if any
                                        }
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: '30%', maxWidth: 200 }}>Company</TableCell>
                                            <TableCell sx={{ width: '15%', maxWidth: 120 }}>GST No</TableCell>
                                            <TableCell sx={{ width: '20%', maxWidth: 140 }}>Contact</TableCell>
                                            <TableCell sx={{ width: '20%', maxWidth: 120 }}>Mobile</TableCell>
                                            <TableCell sx={{ width: '15%', maxWidth: 100 }}>City</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ '& > tr:last-of-type': { borderBottom: '1px solid rgba(0,0,0,0.12)' } }}>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <TableRow key={i} hover onMouseDown={() => onSelectResult(r)} sx={{ cursor: 'pointer', backgroundColor: i % 2 === 0 ? '#fff' : 'rgba(227, 242, 253, 1)', border: 'none' }} >
                                                    <TableCell sx={{ width: '30%', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.FirmName}</TableCell>
                                                    <TableCell sx={{ width: '15%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.GSTNo}</TableCell>
                                                    <TableCell sx={{ width: '20%', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.ContactPerson}</TableCell>
                                                    <TableCell sx={{ width: '20%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.MobileNo}</TableCell>
                                                    <TableCell sx={{ width: '15%', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.City}</TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center">No Data Available</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    <TableFooter sx={{ borderTop: '1px solid rgba(0,0,0,0.12)' }}>
                                        <TableRow hover sx={{ cursor: 'pointer', backgroundColor: '#fff' }} onMouseDown={() => setOpenClientPopup(true)}>
                                            <TableCell colSpan={5} sx={{ textAlign: 'center', color: 'primary.main' }}>
                                                ➕ Add New Client
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        )} */}
                        {dropdownOpen && companyName && (
                            <Paper
                                elevation={0}
                                sx={{
                                    mt: 1,
                                    position: 'absolute',
                                    width: { xs: '100%', lg: '800px' },
                                    zIndex: 10,
                                    border: '1px solid rgba(0,0,0,0.2)',
                                    borderRadius: 1,
                                    maxHeight: 240,
                                    overflowY: 'auto'
                                }}
                            >
                                {isSmallScreen ? (
                                    /* ===================== CARD VIEW (SM / XS) ===================== */
                                    <>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <Box
                                                    key={i}
                                                    sx={{
                                                        p: 1.2,
                                                        borderBottom: '1px solid #eee',
                                                        cursor: 'pointer',
                                                        backgroundColor: i === highlightedIndex ? 'action.selected' : 'transparent'
                                                    }}
                                                    onMouseEnter={() => setHighlightedIndex(i)}
                                                    onMouseDown={() => {
                                                        onSelectResult(r);
                                                        // setSelectedClientId(r.ClientId);
                                                        setCompanyName(toProperCase(r.FirmName));
                                                        setClientError(false);
                                                        setDropdownOpen(false);
                                                    }}
                                                >
                                                    <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                                                        {toProperCase(r.FirmName)}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                        GST: {r.GSTNo || '-'}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem' }}>
                                                        {toProperCase(r.ContactPerson) || '-'} • {r.MobileNo || '-'}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                        {toProperCase(r.City) || '-'}
                                                    </Box>
                                                </Box>
                                            ))
                                        ) : (
                                            <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
                                                Client not found
                                            </Box>
                                        )}

                                        {/* Sticky Add New Client */}
                                        <Box
                                            sx={{
                                                position: 'sticky',
                                                bottom: 0,
                                                backgroundColor: '#fff',
                                                textAlign: 'center',
                                                p: 1,
                                                fontWeight: 600,
                                                color: 'primary.main',
                                                cursor: 'pointer',
                                                boxShadow: '0 -2px 6px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseDown={() => setOpenClientPopup(true)}
                                        >
                                            ➕ Add New Client
                                        </Box>
                                    </>
                                ) : (
                                    /* ===================== TABLE VIEW (MD / LG) ===================== */
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
                                                    <TableCell
                                                        key={h}
                                                        sx={{
                                                            backgroundColor: '#E0E0E0',
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1
                                                        }}
                                                    >
                                                        {h}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {searchResults.length > 0 ? (
                                                searchResults.map((r, i) => (
                                                    <TableRow
                                                        key={i}
                                                        hover
                                                        selected={i === highlightedIndex}
                                                        sx={{ cursor: 'pointer' }}
                                                        onMouseEnter={() => setHighlightedIndex(i)}
                                                        onMouseDown={() => {
                                                            onSelectResult(r);
                                                            setCompanyName(toProperCase(r.FirmName));
                                                            setClientError(false);
                                                            setDropdownOpen(false);
                                                        }}
                                                    >
                                                        <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                                        <TableCell>{r.GSTNo}</TableCell>
                                                        <TableCell>{toProperCase(r.ContactPerson) || "-"}</TableCell>
                                                        <TableCell>{r.MobileNo}</TableCell>
                                                        <TableCell>{toProperCase(r.City)}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
                                                        Client not found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <TableFooter
                                            sx={{
                                                position: 'sticky',
                                                bottom: 0,
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
                                                <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
                                                    ➕ Add New Client
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                )}
                            </Paper>
                        )}
                    </Box>

                    {/* Details display */}
                    <Grid item xs={12} md={4} pt={2}>
                        <TextField fullWidth size="small" label="Address" variant="outlined" disabled value={
                            Array.isArray(details)
                                ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', '))
                                : ''
                        } multiline rows={3.4} InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }}
                            sx={{
                                '& .MuiOutlinedInput-root': { display: 'flex', alignItems: 'center' },
                                '& .MuiOutlinedInput-input': { padding: '0 12px' }
                            }}
                        />
                    </Grid>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Kind Attend" value={kindAttend} onChange={e => setKindAttend(e.target.value)} InputLabelProps={{ shrink: Boolean(kindAttend) }} disabled={!isEditable}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                }}
                            />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Project" value={project} onChange={e => setProject(e.target.value)} InputLabelProps={{ shrink: Boolean(project) }} disabled={!isEditable}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                }}
                            />
                        </Box>
                    </Box>

                    <Box sx={{ mt: 2 }}>
                        <TextField fullWidth size="small" label="Remark" disabled={!isEditable} multiline minRows={1} maxRows={6} value={remark} InputLabelProps={{ shrink: Boolean(remark) }} inputProps={{ maxLength: 250 }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 250) setRemark(val);
                                else setRemark(val.slice(0, 250));
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' }
                            }}
                        />
                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
                            {remark.length}/250
                        </Typography>
                    </Box>

                    <Box display="flex" justifyContent="flex-start">
                        <Box sx={{ width: '20%', mt: "-8px" }}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={termsOptions}
                                getOptionLabel={(opt) => opt?.label || ''}
                                value={selectedTerms}
                                onChange={(_, v) => setSelectedTerms(v)}
                                inputValue={termsInputValue}
                                onInputChange={(_, newInputValue) => setTermsInputValue(newInputValue)}
                                noOptionsText="Not Found"
                                isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
                                // disabled={!isEditable}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Terms"
                                        size="small"
                                        InputLabelProps={{ shrink: Boolean(selectedTerms || termsInputValue) }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                height: 38,
                                                display: 'flex',
                                                alignItems: 'center'
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                fontSize: '0.875rem',
                                                padding: '0 12px'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
                    <Box display="flex" gap={2} flex="1 1 40%">
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Order No." variant='outlined' value={quotationNumber} disabled InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { padding: '0 12px' }
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="Order Date" value={qoutationDate} onChange={setqoutationDate} disabled={!isEditable}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} size="small" fullWidth variant="outlined" value={qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: true }} disabled={!isEditable}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                                    '& .MuiOutlinedInput-input': { padding: '0 12px' }
                                                }}
                                            />
                                        ),
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" variant='outlined' label="Ref. No." value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} InputLabelProps={{ shrink: Boolean(referenceNumber) }} disabled={!isEditable}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="Ref. Date" value={referenceDate} onChange={(newValue) => setReferenceDate(newValue)} disabled={!isEditable}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} fullWidth size="small" variant="outlined" value={referenceDate && referenceDate.isValid() ? referenceDate.format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(referenceDate) }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                                }}
                                            />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        {showCurrency && (
                        <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
                            <Box sx={{ flex: '0 0 50%' }}>
                                {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency)}
                            </Box>
                            <Box sx={{ flex: '0 0 47%' }}>
                                <TextField fullWidth size="small" type="number" variant="outlined" label="Ex Rate" value={exchangeRate} InputLabelProps={{ shrink: Boolean(exchangeRate) }} disabled={!isEditable}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                            setExchangeRate(value);
                                        }
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                        '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                    }}
                                />
                            </Box>
                        </Box>
                        )}
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth label="Agent Name" value={toProperCase(agentName)} onChange={e => setAgentName(toProperCase(e.target.value))} InputLabelProps={{ shrink: Boolean(agentName) }} variant="outlined" size="small" disabled={!isEditable}
                                sx={{
                                    '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' }
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth label="Agent Commission (%)" value={agentCommission} InputLabelProps={{ shrink: Boolean(agentCommission) }} variant="outlined" size="small" type="number" disabled={!isEditable}
                                onChange={e => {
                                    const v = e.target.value;
                                    if (v === '') {
                                        setAgentCommission('');
                                        return;
                                    }
                                    const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
                                    if (re.test(v)) {
                                        setAgentCommission(v);
                                    }
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' }
                                }}
                            />
                        </Box>
                    </Box>

                    <Box sx={{ flex: '0 0 46%', pt: 2 }}>
                        {/* {dropdownField('Account', accountOptions, selectedAccount, setSelectedAccount)} */}
                    </Box>
                </Box>
            </Box>

            {!!error && (<Typography color="error" mt={2}> {error} </Typography>)}

            <Box mt={4} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleNext} disabled={!selectedClientId}>Next</Button>
            </Box>

            {/* Popups */}
            <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                setOpenClientPopup(false);
            }}
                PaperProps={{
                    sx: {
                        width: { xs: "95%", },
                        m: { xs: 0 }
                    }
                }}
            >
                <DialogContent sx={{ p: { xs: 0 } }}>
                    <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
                <DialogContent>
                    <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
                <DialogContent>
                    <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
                <DialogContent>
                    <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
                <DialogContent>
                    <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
                <DialogContent>
                    <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
}
